module.exports = __webpack_public_path__ + "static/img/monitor-dialog-small-bg.fd0f1b98.png";